<template>
  <div id="busca" :class="densidadeClass">
    <el-row style="margin: 20px 0 10px 0">
      <el-col :span="24">
        <h3 class="func-4-title-header">
          Nova busca
        </h3>
      </el-col>
    </el-row>

    <el-row>
      <div>
        <el-tabs ref="tabRef" type="card" v-model="abaAtiva">
          <el-tab-pane
            name="esp"
            :label="funcParametros.textos.labelTipoPesquisaEspecialidade"
            :span="12"
          >
            <el-form :label-position="'top'" @submit.native.prevent class="custom-form">
              <div class="rede-credenciada-form">
                <el-form-item :label="funcParametros.textos.labelBotaoSelecaoPlano" :required="true"
                              :error="errors.first('id_plano')">
                  <el-col :span="24">
                    <el-select ref="selectIdPlanoRef" class="form-select" data-vv-as="id_plano" name="id_plano" v-model="params.id_plano"
                               placeholder="Selecione" :disabled="!planoOptions || planoOptions.length === 0" filterable
                               :default-first-option="true" clearable
                               @clear="clearSelectedItem('plano')"
                               @change="changePlano"
                    >
                      <el-option-group
                        v-for="group in planoOptions"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option v-for="(item, index) in group.options" :key="index" :value="item.codigo_legado"
                                   :label="item.descricao" class="extended-option">
                          <div class="bold">
                            {{ item.descricao }}
                          </div>
                          <div class="text-ellipses">
                            <span>N° ANS:</span>
                            <span>{{ item.registro_plano_ANS }}</span>
                            <span> - </span>
                            <span>{{ item.classificacao_fins_comercializacao }}</span>
                          </div>
                          <div class="text-ellipses">
                            {{ item.situacao_plano_comercializacao }}
                          </div>
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </el-col>
                </el-form-item>

                <el-row>
                  <el-col
                    :span="columnsConfig.localizacao"
                  >
                    <el-form-item
                      :label="funcParametros.textos.labelBotaoSelecaoLocalizacao"
                      :required="true"
                      v-if="permiteGeolocalizacao"
                      :error="errors.first('tipo_localizacao')"
                    >
                      <el-select
                          ref="selectIdTipoLocalizacao"
                          class="form-select select-localizacao"
                          data-vv-as="tipo_localizacao"
                          name="tipo_localizacao"
                          placeholder="Selecione"
                          :disabled="!params.id_plano || waitingPermissionGeolocation"
                          v-model="tipoLocalizacao"
                          :default-first-option="true" clearable @clear="clearSelectedItem('localizacao')"
                          @change="onChangeTipoLocalizacao"
                      >
                        <el-option :key="1" value="geolocation" :label="waitingPermissionGeolocation ? 'Aguardando localização' : 'Mais próximo de mim'" class="extended-option option-geolocation">
                          <span class="option-geolocation-title">Mais próximos</span>
                          <el-button type="primary" @click="useGeolocation">USAR LOCALIZAÇÃO</el-button>
                        </el-option>
                        <el-option :key="2" value="address" label="Estado, Cidade e Bairro" class="extended-option option-address">
                          <span>Selecionar Estado, Cidade e Bairro</span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="columnsConfig.estados"
                    v-if="tipoLocalizacao === EnumTipoLocalizacao.ADDRESS || !permiteGeolocalizacao"
                  >
                    <el-form-item :label="funcParametros.textos.labelBotaoSelecaoEstado" :required="true"
                                  :error="errors.first('id_estado')" :class="{'select-estado': tipoLocalizacao === EnumTipoLocalizacao.ADDRESS}">
                      <el-select ref="selectIdEstadoRef" class="form-select" data-vv-as="id_estd" name="id_estd"
                                 v-model="params.id_estado" placeholder="Selecione"
                                 :loading="loading"
                                 loading-text="Carregando..."
                                 :disabled="!params.id_plano || permiteGeolocalizacao && !tipoLocalizacao" filterable
                                 :default-first-option="true" clearable @clear="clearSelectedItem('estado')"
                                 @focus="buscaEstados" @change="changeEstado">
                        <el-option v-for="item in estadoOptions" :key="item.id" :label="item.uf"
                                   :value="item.uf"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="columnsConfig.cidades"
                    v-if="tipoLocalizacao === EnumTipoLocalizacao.ADDRESS || !permiteGeolocalizacao"
                  >
                    <el-form-item :label="funcParametros.textos.labelBotaoSelecaoCidade" :required="true"
                                  :error="errors.first('id_cidade')" :span="12"
                                  :class="{'select-city': !tipoLocalizacao || tipoLocalizacao === 'geolocation'}">
                      <el-select ref="selectIdCidadeRef" class="form-select" data-vv-as="id_cidd" name="id_cidd"
                                 v-model="params.id_cidade" placeholder="Selecione"
                                 :loading="loading"
                                 loading-text="Carregando..."
                                 :disabled="!params.id_estado" filterable
                                 :default-first-option="true" clearable @clear="clearSelectedItem('cidade')"
                                 @focus="buscaCidades" @change="changeCidade">
                        <el-option v-for="item in cidadeOptions" :key="item.id" :label="item.nome"
                                   :value="item.codigo_IBGE">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="columnsConfig.bairros"
                    v-if="tipoLocalizacao === EnumTipoLocalizacao.ADDRESS || !permiteGeolocalizacao"
                  >
                    <el-form-item :label="funcParametros.textos.labelBotaoSelecaoBairro" :required="true"
                                  :error="errors.first('id_bairro')" :class="{'select-bairro': tipoLocalizacao === EnumTipoLocalizacao.ADDRESS}">
                      <el-select ref="selectIdBairroRef" class="form-select" data-vv-as="id_bair" name="id_bair"
                                 v-model="params.id_bairro"
                                 :loading="loading"
                                 loading-text="Carregando..."
                                 placeholder="Selecione" :disabled="!(params.id_cidade !== 'TODOS') || !params.id_cidade"
                                 filterable :default-first-option="true" clearable @clear="clearSelectedItem('bairro')"
                                 @focus="buscaBairros" @change="changeBairro">
                        <el-option v-for="item in bairroOptions" :key="item.bairro" :label="item.bairro"
                                   :value="item.bairro">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :label="funcParametros.textos.labelBotaoSelecaoTipoPrestador"
                                  :required="funcParametros.tipoPrestadorObrigatorio"
                                  :error="errors.first('tipo_prestador')">
                        <el-select
                          ref="selectIdTipoPrestadorRef"
                          class="form-select"
                          data-vv-as="id_tipo_prestador"
                          name="id_tipo_prestador"
                          v-model="params.id_tipo_prestador"
                          placeholder="Selecione"
                          :loading="loading"
                          loading-text="Carregando..."
                          :disabled="(
                            waitingPermissionGeolocation || (permiteGeolocalizacao && !tipoLocalizacao ||
                            (tipoLocalizacao === EnumTipoLocalizacao.ADDRESS && !(this.params.id_cidade === 'TODOS') && !params.id_cidade) ||
                            ((this.params.id_cidade !== 'TODOS') && params.id_cidade && !params.id_bairro))) || !params.id_plano" filterable
                          :default-first-option="true" clearable @clear="clearSelectedItem('tipo_prestador')"
                          @focus="buscaTipoPrestador"
                          @change="changeTipoPrestador"
                          no-data-text="Nenhum resultado encontrado"
                          >
                          <template v-if="tipoPrestadorOptions && tipoPrestadorOptions.length > 0">
                          <el-option
                            v-for="item in listOptionsPrestadores"
                            :key="item.classe"
                            :label="item.descricao"
                            :value="item.classe"
                            >
                          </el-option>
                          </template>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :label="funcParametros.textos.labelBotaoSelecaoEspecialidade"
                                  :required="funcParametros.especialidadeObrigatorio"
                                  :error="errors.first('especialidade')">
                        <el-select
                          ref="selectIdEspecialidadeRef"
                          class="form-select"
                          data-vv-as="id_especialidade"
                          name="id_especialidade"
                          :loading="loading"
                          loading-text="Carregando..."
                          v-model="params.id_especialidade"
                          placeholder="Selecione"
                          :disabled="(
                            waitingPermissionGeolocation || (permiteGeolocalizacao && !tipoLocalizacao ||
                            (tipoLocalizacao === EnumTipoLocalizacao.ADDRESS && !(this.params.id_cidade === 'TODOS') && !params.id_cidade) ||
                            ((this.params.id_cidade !== 'TODOS') && params.id_cidade && !params.id_bairro))) || !params.id_plano" filterable
                          :default-first-option="true"
                          clearable @clear="clearSelectedItem('especialidade')"
                          @change="clearSelectedItem('subespecialidade')"
                          @focus="buscaEspecialidades"
                          no-data-text="Nenhum resultado encontrado"
                          >
                          <template v-if="especialidadeOptions && especialidadeOptions.length > 0">
                          <el-option
                            v-for="item in listOptionsEspecialidades"
                              :key="item.codigo_CBO"
                              :label="item.descricao"
                              :value="item.codigo_CBO"
                            >
                            </el-option>
                          </template>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="isSubespecialidades">
                  <el-col :span="24">
                    <el-form-item :label="funcParametros.textos.labelBotaoSelecaoSubespecialidade || 'Subespecialidade'"
                                  :error="errors.first('subespecialidade')">
                        <el-select
                          ref="selectIdSubespecialidadeRef"
                          class="form-select"
                          data-vv-as="id_subespecialidade"
                          name="id_subespecialidade"
                          :loading="loading"
                          loading-text="Carregando..."
                          v-model="params.id_subespecialidade"
                          placeholder="Selecione"
                          :disabled="(
                            waitingPermissionGeolocation || (permiteGeolocalizacao && !tipoLocalizacao ||
                            (tipoLocalizacao === EnumTipoLocalizacao.ADDRESS && !(this.params.id_cidade === 'TODOS') && !params.id_cidade) ||
                            ((this.params.id_cidade !== 'TODOS') && params.id_cidade && !params.id_bairro))) || !params.id_plano" filterable
                          :default-first-option="true"
                          clearable @clear="clearSelectedItem('subespecialidade')"
                          @focus="buscaSubespecialidades"
                          no-data-text="Nenhum resultado encontrado"
                          >
                          <template v-if="subespecialidadeOptions && subespecialidadeOptions.length > 0">
                          <el-option
                            v-for="item in listOptionsSubespecialidades"
                              :key="item.cod_legado"
                              :label="item.descricao"
                              :value="item.cod_legado"
                            >
                            </el-option>
                          </template>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="alertError">
                  <AlertaErro v-model="alertError" :title="errosValidacao.titulo"
                              :description="errosValidacao.descricao" style="margin-top:14px" />
                </el-row>

                <el-row>
                  <el-button
                    :style="`background: ${estilo.aplicacao.corPrimariaAplicacao}; color: white`"
                    @click="search()"
                    class="func-4-btn-pesquisar"
                    :disabled="waitingPermissionGeolocation"
                  >
                    {{ funcParametros.textos.labelBotaoPesquisar }}
                  </el-button>
                </el-row>

              </div>
            </el-form>

          </el-tab-pane>

          <el-tab-pane
            name="nome"
            :label="funcParametros.textos.labelTipoPesquisaNome"
            :span="12"
          >
            <el-form :label-position="'top'" label-width="190px" @submit.native.prevent>
              <div class="rede-credenciada-form">
                <el-form-item :label="funcParametros.textos.labelBotaoSelecaoPlano" :required="true"
                              :error="errors.first('plano')">
                  <el-col :span="24">
                    <el-select ref="selectIdPlanoRef" class="form-select" data-vv-as="id_plano" name="id_plano" v-model="params.id_plano"
                               placeholder="Selecione" :disabled="!planoOptions || planoOptions.length === 0" filterable
                               :default-first-option="true" clearable
                               @clear="clearSelectedItem('plano')"
                               @change="changePlano"
                    >
                      <el-option-group
                        v-for="group in planoOptions"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option v-for="(item, index) in group.options" :key="index" :value="item.codigo_legado"
                                   :label="item.descricao" class="extended-option">
                          <div class="bold">
                            {{ item.descricao }}
                          </div>
                          <div class="text-ellipses">
                            <span>N° ANS:</span>
                            <span>{{ item.registro_plano_ANS }}</span>
                            <span> - </span>
                            <span>{{ item.classificacao_fins_comercializacao }}</span>
                          </div>
                          <div class="text-ellipses">
                            {{ item.situacao_plano_comercializacao }}
                          </div>
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </el-col>
                </el-form-item>

                <el-form-item label="Nome" :required="true" :error="errors.first('nome')">
                  <el-col :span="24">
                    <div class="el-input el-input--suffix">
                      <input ref="selectPlanoNomeRef" type="text" v-model="params.nome" class="el-input__inner"
                             name="nome" />
                    </div>
                  </el-col>
                </el-form-item>

                <el-row v-if="alertError">
                  <AlertaErro v-model="alertError" :title="errosValidacao.titulo"
                              :description="errosValidacao.descricao" style="margin-top:14px" />
                </el-row>

                <el-row>
                  <el-button @click="search()" class="func-4-btn-pesquisar">
                    {{ funcParametros.textos.labelBotaoPesquisar }}
                  </el-button>
                </el-row>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <div v-if="funcParametros.exibeDescredenciados">
          <el-button
            class="descredenciados-btn"
            @click="abrirDescredenciados"
          >
            <span>Descredenciados</span>
            <i class="material-icons-outlined">
              chevron_right
            </i>
          </el-button>
        </div>
      </div>

      <ul v-if="!isWidget" class="func-listagens">
        <li v-if="funcParametros.exibeGuiaImpresso" :style="`margin-bottom: 10px; border-radius: 6px; ${estiloLinha}; height: 49px;`" @click="openGuiaImpresso">
          <el-row class="button-text" style="margin-bottom: 0; cursor:pointer; align-items: center;">
            <el-col :span="22" style="padding-left: 15px; display: flex; align-items: center; height: 100%;">
              <h2 class="func-4-title">{{ funcParametros.textos.labelBotaoGuiaImpresso }}</h2>
            </el-col>
            <el-col :span="2" class="button-icon" style="display: flex; align-items: center; justify-content: center; height: 100%;">
              <i class="el-icon-arrow-right"
                 :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}; font-size: 16px; font-weight: bold;`"></i>
            </el-col>
          </el-row>
        </li>
        <li :style="`margin-bottom: 10px; border-radius: 6px; ${estiloLinha}`">
          <el-row class="func-4-label-item-loja">
            <el-col :span="22">
              <h2 class="func-4-title">Instale nosso app gratuito</h2>
            </el-col>
          </el-row>
          <div class="func-4-item download-app" style="margin-bottom: 5px" :gutter="85">
            <div @click="openIos">
              <img src="../../assets/img/img_download_ios@2x.png" class="func-4-btn-loja" alt="none" />
            </div>
            <div @click="openAndroid">
              <img src="../../assets/img/img_download_android@2x.png" class="func-4-btn-loja" alt="none" />
            </div>
          </div>
        </li>
      </ul>
    </el-row>

    <dialog-default
      :open.sync="dialogError.show"
      :show-close="false"
      :close-on-click-modal="false"
      :title="dialogError.titulo"
    >

      <el-row style="margin-bottom: 10px">
        <el-col :span="24">
          <p>Parâmetros de busca incompletos.</p>
          <p v-html="dialogError.descricao"></p>
        </el-col>
      </el-row>

      <template v-slot:footer>
        <el-row>
          <el-col :span="24">
            <el-button :style="`background: ${estilo.aplicacao.corPrimariaAplicacao}; color: white`"
                       class="func-4-btn-block" @click="dialogError.show = false">
              OK
            </el-button>
          </el-col>
        </el-row>
      </template>
    </dialog-default>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import { applyTextFormat } from '@/utils/formatTexto'
import AlertaErro from '@/components/AlertaError/AlertaErro'
import { EnumFiltros, EnumGeolocationPermissionState, EnumTipoLocalizacao } from '@/constants/EnumsRedeCredenciada'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'

const sessionFilterKey = 'rede_credenciada_filter'

export default {
  name: 'Func4BuscaRedeCredenciada',
  components: { DialogDefault, AlertaErro },
  props: {
    getGeolocation: Function,
    changeFilters: Object
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'frameId']),
    ...mapGetters('Login', ['token', 'user', 'contratos', 'beneficiarios']),
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'configuracaoAcesso', 'isWidget']),
    ...mapState('RedeCredenciada', [
      'densidade',
      'geolocalizacao',
      'permiteGeolocalizacao',
      'solicitaGeolocalizacaoNoCarregamento',
      'filtros',
      'filtroPlanos'
    ]),
    densidadeClass () {
      return 'densidade-' + this.densidade
    },
    clientKey () {
      return this.user && this.user.selectedClient && this.user.selectedClient.clientKey
    },
    estiloLinha () {
      return `background: ${this.estilo.aplicacao.corPrimariaAplicacao}0d !important`
    },
    corPrimariaAplicacao () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    funcParametros () {
      return this.funcionalidade.parametros
    },
    EnumTipoLocalizacao () {
      return EnumTipoLocalizacao
    },
    listOptionsPrestadores () {
      const labelOpcaoTodosCampoSelecaoTipoPrestador = this.funcParametros.textos.labelOpcaoTodosCampoSelecaoTipoPrestador
      const todosPrestadores = {
        classe: '',
        descricao: labelOpcaoTodosCampoSelecaoTipoPrestador || 'TODOS'
      }
      if (this.funcParametros.exibeOpcaoTodosCampoSelecaoTipoPrestador) {
        return [ todosPrestadores, ...this.tipoPrestadorOptions ]
      }
      return this.tipoPrestadorOptions
    },
    listOptionsEspecialidades () {
      const labelOpcaoTodosCampoSelecaoEspecialidade = this.funcParametros.textos.labelOpcaoTodosCampoSelecaoEspecialidade
      const todasEspecialidades = {
        codigo_CBO: '',
        descricao: labelOpcaoTodosCampoSelecaoEspecialidade || 'TODAS',
        codigo_legado: ''
      }
      if (this.funcParametros.exibeOpcaoTodosCampoSelecaoEspecialidade) {
        return [ todasEspecialidades, ...this.especialidadeOptions ]
      }
      return this.especialidadeOptions
    },
    listOptionsSubespecialidades () {
      const labelOpcaoTodosCampoSelecaoSubespecialidade = this.funcParametros.textos.labelOpcaoTodosCampoSelecaoSubespecialidade
      const todasSubespecialidades = {
        codigo_CBO: '',
        descricao: labelOpcaoTodosCampoSelecaoSubespecialidade || 'TODAS',
        codigo_legado: ''
      }
      if (this.funcParametros.exibeOpcaoTodosCampoSelecaoSubespecialidade) {
        return [ todasSubespecialidades, ...this.subespecialidadeOptions ]
      }
      return this.subespecialidadeOptions
    },
    isSubespecialidades () {
      const sub = this.especialidadeOptions.find((s) => s.codigo_CBO === this.params.id_especialidade)
      if (sub) {
        return !!sub.subespec
      }
      return false
    }
  },
  data () {
    return {
      params: {
        id_plano: null,
        id_estado: null,
        id_cidade: null,
        id_bairro: null,
        id_tipo_prestador: null,
        id_especialidade: null,
        id_subespecialidade: null,
        nome: null,
        orderDist: false,
        orderAlfa: false,
        lat: null,
        lon: null
      },
      tipoLocalizacao: null,
      loading: false,
      planoOptions: [],
      estadoOptions: [],
      cidadeOptions: [],
      bairroOptions: [],
      tipoPrestadorOptions: [],
      especialidadeOptions: [],
      subespecialidadeOptions: [],
      redeCredenciada: [],
      locations: [],
      acreditacaoLegendas: [],
      activeNames: [],
      totalRegistros: 0,
      dialogError: {
        show: false,
        titulo: 'Atenção',
        descricao: null
      },
      alertError: false,
      errosValidacao: {
        titulo: 'Atenção',
        descricao: null
      },
      columnsConfig: {
        localizacao: 24,
        estados: 8,
        cidades: 16,
        bairros: 24
      },
      abaAtiva: 'esp', // esp ou nome,
      waitingPermissionGeolocation: false
    }
  },
  methods: {
    ...mapActions('RedeCredenciada', [
      'setLoading',
      'setRedeCredenciada',
      'setServerError',
      'setShowRedeVazia',
      'setViewDetalhe',
      'setViewGuiaImpresso',
      'setFiltros',
      'setGeolocalizacao',
      'setFiltroPlanos'
    ]),
    openIos () {
      const URL = `https://apps.apple.com/br/app/${this.aplicacao.idAppLojaIos}`
      window.open(URL, '_blank')
    },
    openAndroid () {
      const URL = `https://play.google.com/store/apps/details?id=${this.aplicacao.idAppLojaAndroid}`
      window.open(URL, '_blank')
    },
    async init () {
      await this.buscaPlanos()
      if (this.solicitaGeolocalizacaoNoCarregamento || this.geolocalizacao.permissionState === EnumGeolocationPermissionState.GRANTED) {
        this.getGeolocation()
      }
    },
    initFilters () {
      if (this.densidade > 0) return

      const filterJson = window.sessionStorage.getItem(sessionFilterKey)

      if (!filterJson) return

      const filter = JSON.parse(filterJson)

      this.params = filter.params
      this.planoOptions = filter.options.planos
      this.estadoOptions = filter.options.estados
      this.cidadeOptions = filter.options.cidades
      this.bairroOptions = filter.options.bairros
      this.tipoPrestadorOptions = filter.options.tiposPrestador
      this.especialidadeOptions = filter.options.especialidades
      this.abaAtiva = filter.aba
      this.tipoLocalizacao = filter.tipoLocalizacao

      if (filter.aba === 'nome') this.$refs.tabRef.currentName = 'nome'

      setTimeout(() => {
        this.$refs.selectIdPlanoRef.selectedLabel = filter.labels.idPlanoLabel
        if (this.$refs.selectIdTipoLocalizacao) {
          this.$refs.selectIdTipoLocalizacao.selectedLabel = filter.labels.idTipoLocalizacao
          this.tipoLocalizacao = filter.tipoLocalizacao
        }
        if (this.$refs.selectIdEstadoRef) this.$refs.selectIdEstadoRef.selectedLabel = filter.labels.idEstadoLabel
        if (this.$refs.selectIdCidadeRef) this.$refs.selectIdCidadeRef.selectedLabel = filter.labels.idCidadeLabel
        if (this.$refs.selectIdCidadeRef) this.$refs.selectIdBairroRef.selectedLabel = filter.labels.idBairroLabel
        this.$refs.selectIdTipoPrestadorRef.selectedLabel = filter.labels.idTipoPrestadorLabel
        this.$refs.selectIdEspecialidadeRef.selectedLabel = filter.labels.idEspecialidadeLabel
        this.$refs.selectIdPlanoByNameRef.selectedLabel = filter.labels.idPlanoByNameLabel
        this.$refs.selectPlanoNomeRef.value = filter.labels.nomePlanoLabel
      }, 350)

      const filtersApplied = {
        order: filter.params.orderDist ? EnumFiltros.ORDER_DIST : EnumFiltros.ORDER_ALFA
      }
      this.search(filtersApplied)
    },
    clearSelectedItem (idELemento) {
      switch (idELemento) {
        case 'plano':
          this.params.id_plano = null

          this.tipoLocalizacao = null
          this.columnsConfig.localizacao = 24

          this.estadoOptions = null
          this.params.id_estado = null

          this.cidadeOptions = null
          this.params.id_cidade = null

          this.bairroOptions = null
          this.params.id_bairro = null

          this.tipoPrestadorOptions = null
          this.params.id_tipo_prestador = null

          this.especialidadeOptions = null
          this.params.id_especialidade = null
          this.especialidadeOptions = []
          this.params.id_subespecialidade = null
          this.subespecialidadeOptions = []
          break
        case 'estado':
          this.params.id_estado = null

          this.cidadeOptions = null
          this.params.id_cidade = null

          this.bairroOptions = null
          this.params.id_bairro = null

          this.tipoPrestadorOptions = null
          this.params.id_tipo_prestador = null

          this.especialidadeOptions = null
          this.params.id_especialidade = null
          this.especialidadeOptions = []
          this.params.id_subespecialidade = null
          this.subespecialidadeOptions = []
          break
        case 'cidade':
          this.params.id_cidade = null

          this.bairroOptions = null
          this.params.id_bairro = null

          this.tipoPrestadorOptions = null
          this.params.id_tipo_prestador = null

          this.especialidadeOptions = null
          this.params.id_especialidade = null
          this.especialidadeOptions = []
          this.params.id_subespecialidade = null
          this.subespecialidadeOptions = []
          break
        case 'bairro':
          this.params.id_bairro = null

          this.tipoPrestadorOptions = null
          this.params.id_tipo_prestador = null

          this.especialidadeOptions = null
          this.params.id_especialidade = null
          this.especialidadeOptions = []
          this.params.id_subespecialidade = null
          this.subespecialidadeOptions = []
          break
        case 'tipo_prestador':
          this.params.id_tipo_prestador = null

          this.especialidadeOptions = null
          this.params.id_especialidade = null
          this.especialidadeOptions = []
          this.params.id_subespecialidade = null
          this.subespecialidadeOptions = []
          break
        case 'especialidade':
          this.params.id_especialidade = null
          this.especialidadeOptions = []
          this.params.id_subespecialidade = null
          this.subespecialidadeOptions = []
          break
        case 'subespecialidade':
          this.params.id_subespecialidade = null
          this.subespecialidadeOptions = []
          break
        case 'plano_aba_nome':
          this.params.id_plano = null
          break
      }
    },
    async buscaPlanos () {
      this.planoOptions = []

      if (this.beneficiarios && this.beneficiarios.length > 0) {
        if (!this.funcParametros.usuarioLogadoVisualizaTodosPlanos) {
          let plano = ''
          this.beneficiarios.map((item) => {
            if (item.dadosDoPlano.idPlano !== plano) {
              this.planoOptions.push(item.dadosDoPlano.idPlano)
              plano = item.dadosDoPlano.idPlano
            }
          })
        }
      }

      this.setFiltroPlanos(this.filtroPlanos.concat(this.planoOptions))

      const result = await this.apiFuncionalidade.listaPlanos({
        payload: { idOperadora: this.aplicacao.idOperadora, planos: this.filtroPlanos },
        handlerErrorIgnore: [404]
      })

      if (result.code === 404) return this.showEmpty()

      this.planoOptions = result.data

      if (this.planoOptions.length && this.planoOptions.length < 2) {
        this.params.id_plano = this.planoOptions[0].codigo_legado
      }
      if (Array.isArray(this.beneficiarios)) {
        if (this.beneficiarios.length === 1) {
          this.params.id_plano = this.beneficiarios[0].dadosDoPlano.idPlano
        }
      } else {
        if (Array.isArray(this.planoOptions) && this.planoOptions.length === 1) {
          this.params.id_plano = this.planoOptions[0].codigo_legado
        }
      }

      let meusPlanos = []

      if (Array.isArray(this.beneficiarios)) {
        this.beneficiarios.forEach((beneficiario) => {
          let meuPlano = this.planoOptions.find((plano) => {
            return plano.codigo_legado === beneficiario.dadosDoPlano.idPlano
          })

          if (meuPlano) {
            if (
              meusPlanos.length > 0 &&
              meusPlanos.find((planoInserido) => planoInserido.id === meuPlano.id)
            ) {
              meusPlanos = meusPlanos.map((plano) => {
                if (plano.id === meuPlano.id) {
                  return {
                    ...plano
                  }
                } else {
                  return plano
                }
              })
            } else {
              meusPlanos.push({
                ...meuPlano
              })
            }
          }
        })
      }

      this.planoOptions = [
        {
          label: 'Meus Planos',
          options: meusPlanos
        },
        {
          label: 'Outros Planos',
          options: this.planoOptions
        }
      ]
    },
    changePlano () {
      this.params.id_estado = null
      this.params.id_cidade = null
      this.params.id_bairro = null
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.estadoOptions = []
      this.cidadeOptions = []
      this.bairroOptions = []
      this.tipoPrestadorOptions = []
      this.especialidadeOptions = []
      this.subespecialidadeOptions = []
    },
    changeEstado () {
      this.params.id_cidade = null
      this.params.id_bairro = null
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.cidadeOptions = []
      this.bairroOptions = []
      this.tipoPrestadorOptions = []
      this.especialidadeOptions = []
      this.subespecialidadeOptions = []
    },
    async buscaEstados () {
      if (Array.isArray(this.estadoOptions) && this.estadoOptions.length > 0) {
        return
      }

      this.loading = true
      this.params.id_estado = null
      this.params.id_cidade = null
      this.params.id_bairro = null
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.estadoOptions = []
      this.cidadeOptions = []
      this.bairroOptions = []
      this.tipoPrestadorOptions = []
      this.especialidadeOptions = []

      if (!this.params.id_plano) {
        return
      }
      const result = await this.apiFuncionalidade.listaEstados({
        payload: { idOperadora: this.aplicacao.idOperadora, idPlano: this.params.id_plano },
        handlerErrorIgnore: [404]
      })
      if (result.data) {
        this.estadoOptions = result.data
      }
      this.loading = false
    },
    changeCidade () {
      this.params.id_bairro = null
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.bairroOptions = []
      this.tipoPrestadorOptions = []
      this.especialidadeOptions = []
    },
    async buscaCidades () {
      if (Array.isArray(this.cidadeOptions) && this.cidadeOptions.length > 0) {
        return
      }
      this.loading = true
      this.params.id_cidade = null
      this.params.id_bairro = null
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.cidadeOptions = []
      this.bairroOptions = []
      this.tipoPrestadorOptions = []
      this.especialidadeOptions = []
      this.subespecialidadeOptions = []

      if (!this.params.id_estado) {
        return
      }
      const result = await this.apiFuncionalidade.listaCidades({
        payload: {
          idOperadora: this.aplicacao.idOperadora,
          idPlano: this.params.id_plano,
          idEstado: this.params.id_estado
        },
        handlerErrorIgnore: [404]
      })
      if (result.data) {
        this.cidadeOptions = result.data
        this.cidadeOptions.unshift({ codigo_IBGE: 'TODOS', nome: 'TODOS' })
      }
      this.loading = false
    },
    changeBairro () {
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.tipoPrestadorOptions = []
      this.especialidadeOptions = []
      this.subespecialidadeOptions = []
    },
    async buscaBairros () {
      if (Array.isArray(this.bairroOptions) && this.bairroOptions.length > 0) {
        return
      }
      this.loading = true
      this.params.id_bairro = null
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.bairroOptions = []
      this.tipoPrestadorOptions = []
      this.especialidadeOptions = []
      this.subespecialidadeOptions = []

      if (!this.params.id_cidade || this.params.id_cidade === '' || this.params.id_cidade === 'TODOS') {
        // await this.buscaTipoPrestador()
        // await this.buscaEspecialidades()
        return
      }
      const result = await this.apiFuncionalidade.listaBairros({
        payload: {
          idOperadora: this.aplicacao.idOperadora,
          idPlano: this.params.id_plano,
          idEstado: this.params.id_estado,
          idCidade: this.params.id_cidade === 'TODOS' ? '' : this.params.id_cidade
        },
        handlerErrorIgnore: [404]
      })
      if (result.data) {
        this.bairroOptions = result.data
        this.bairroOptions.unshift({ bairro: 'TODOS' })
      }
      this.loading = false
    },
    changeTipoPrestador () {
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.especialidadeOptions = []
      this.subespecialidadeOptions = []
    },
    async buscaTipoPrestador () {
      if (Array.isArray(this.tipoPrestadorOptions) && this.tipoPrestadorOptions.length > 0) {
        return
      }
      this.loading = true
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.tipoPrestadorOptions = []
      this.especialidadeOptions = []
      this.subespecialidadeOptions = []

      const result = await this.apiFuncionalidade.tipoPrestador({
        payload: {
          idOperadora: this.aplicacao.idOperadora,
          idPlano: this.params.id_plano,
          idEstado: this.params.id_estado,
          idCidade: this.params.id_cidade === 'TODOS' ? '' : this.params.id_cidade,
          bairro: this.params.id_bairro === 'TODOS' ? '' : this.params.id_bairro,
          lat: this.geolocalizacao.lat || this.params.lat,
          lon: this.geolocalizacao.lng || this.params.lon,
          dist: this.funcParametros.raioBuscaKm
        },
        handlerErrorIgnore: [404]
      })
      if (result.data) {
        this.tipoPrestadorOptions = result.data
        // this.tipoPrestadorOptions.unshift({ classe: '', descricao: 'TODOS' })
      }
      this.loading = false
    },
    async buscaEspecialidades () {
      if (Array.isArray(this.especialidadeOptions) && this.especialidadeOptions.length > 0) {
        return
      }
      this.loading = true
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null

      this.especialidadeOptions = []
      this.subespecialidadeOptions = []

      const result = await this.apiFuncionalidade.listaEspecialidades({
        payload: {
          idOperadora: this.aplicacao.idOperadora,
          idPlano: this.params.id_plano,
          idEstado: this.params.id_estado,
          idCidade: this.params.id_cidade === 'TODOS' ? '' : this.params.id_cidade,
          bairro: this.params.id_bairro === 'TODOS' ? '' : this.params.id_bairro,
          tpprest: this.params.id_tipo_prestador,
          lat: this.geolocalizacao.lat || this.params.lat,
          lon: this.geolocalizacao.lng || this.params.lon,
          dist: this.funcParametros.raioBuscaKm
        },
        handlerErrorIgnore: [404]
      })
      if (result.data) {
        this.especialidadeOptions = result.data
        // this.especialidadeOptions.unshift({ codigo_CBO: 'todos', descricao: 'Todos' })
      }
      this.loading = false
    },
    async buscaSubespecialidades () {
      if (Array.isArray(this.subespecialidadeOptions) && this.subespecialidadeOptions.length > 0) {
        return
      }
      this.loading = true
      this.params.id_subespecialidade = null

      this.subespecialidadeOptions = []

      const result = await this.apiFuncionalidade.listaSubespecialidades({
        payload: {
          idOperadora: this.aplicacao.idOperadora,
          // idConfigClienteApp: this.aplicacao.idConfigClienteApp,
          idPlano: this.params.id_plano,
          idEstado: this.params.id_estado,
          idCidade: this.params.id_cidade === 'TODOS' ? '' : this.params.id_cidade,
          bairro: this.params.id_bairro === 'TODOS' ? '' : this.params.id_bairro,
          tpprest: this.params.id_tipo_prestador,
          lat: this.geolocalizacao.lat || this.params.lat,
          lon: this.geolocalizacao.lng || this.params.lon,
          dist: this.funcParametros.raioBuscaKm,
          espec: this.params.id_especialidade
        },
        handlerErrorIgnore: [404]
      })
      if (result.data) {
        this.subespecialidadeOptions = result.data
        // this.subespecialidadeOptions.unshift({ codigo_CBO: 'todos', descricao: 'Todos' })
      }
      this.loading = false
    },
    async clearForm () {
      this.alertError = false

      this.cidadeOptions = []
      this.bairroOptions = []
      this.tipoPrestadorOptions = []
      this.especialidadeOptions = []
      this.subespecialidadeOptions = []

      // this.params.id_plano = null
      this.params.id_estado = null
      this.params.id_cidade = null
      this.params.id_bairro = null
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null
      this.params.nome = null

      await this.buscaPlanos()
    },
    goToCompleteVersion () {
      const urlEmbedCompleto = this.funcionalidade.parametros.web.urlEmbedCompleto

      if (!urlEmbedCompleto) throw new Error('Parâmetro "urlEmbedCompleto" inválido.')

      const labels = {
        idPlanoLabel: this.$refs.selectIdPlanoRef.selectedLabel,
        idTipoLocalizacao: this.$refs.selectIdTipoLocalizacao ? this.$refs.selectIdTipoLocalizacao.selectedLabel : null,
        idEstadoLabel: this.$refs.selectIdEstadoRef ? this.$refs.selectIdEstadoRef.selectedLabel : null,
        idCidadeLabel: this.$refs.selectIdCidadeRef ? this.$refs.selectIdCidadeRef.selectedLabel : null,
        idBairroLabel: this.$refs.selectIdBairroRef ? this.$refs.selectIdBairroRef.selectedLabel : null,
        idTipoPrestadorLabel: this.$refs.selectIdTipoPrestadorRef.selectedLabel,
        idEspecialidadeLabel: this.$refs.selectIdEspecialidadeRef.selectedLabel,
        idPlanoByNameLabel: this.$refs.selectIdPlanoRef.selectedLabel,
        nomePlanoLabel: this.$refs.selectPlanoNomeRef.value
      }

      const options = {
        planos: this.planoOptions,
        estados: this.estadoOptions,
        cidades: this.cidadeOptions,
        bairros: this.bairroOptions,
        tiposPrestador: this.tipoPrestadorOptions,
        especialidades: this.especialidadeOptions
      }

      const params = this.params
      const filter = { aba: this.abaAtiva, labels, params, options, tipoLocalizacao: this.tipoLocalizacao }
      const filterJson = JSON.stringify(filter)

      window.sessionStorage.setItem(sessionFilterKey, filterJson)

      const eventData = {
        type: 'GO_TO_COMPLETE_PAGE',
        urlEmbedCompleto
      }

      window.top.postMessage(eventData, '*')
    },
    disableAutocomplete () {
      const inputs = this.$refs.tabRef.$el.getElementsByTagName('input')

      for (const input of inputs) {
        input.setAttribute('readonly', 'readonly')
        input.setAttribute('autocomplete', 'off')
        setTimeout(() => input.removeAttribute('readonly'), 500)
      }
    },
    validateForm () {
      let erros = ''
      this.dialogError.descricao = ''
      if (!this.params.id_plano || this.params.id_plano === '') {
        erros += `<li><b>Plano</b></li>`
      }

      if (this.abaAtiva === 'esp') {
        if (this.tipoLocalizacao === EnumTipoLocalizacao.ADDRESS) {
          if (!this.params.id_estado || this.params.id_estado === '') {
            erros += `<li><b>Estado</b></li>`
          }

          if (!this.params.id_cidade || this.params.id_cidade === '') {
            erros += `<li><b>Cidade</b></li>`
          }
          if (this.params.id_cidade !== 'TODOS' && (!this.params.id_bairro || this.params.id_bairro === '')) {
            erros += `<li><b>Bairro</b></li>`
          }
        }

        if ((!this.params.id_tipo_prestador || this.params.id_tipo_prestador === '') &&
          (!this.params.id_especialidade || this.params.id_especialidade === '')) {
          erros += `<li>${this.funcParametros.textos.textoErroBuscaRede}</li>`
        } else {
          if (this.funcParametros.tipoPrestadorObrigatorio && (!this.params.id_tipo_prestador || this.params.id_tipo_prestador === '')) {
            erros += `<li>${this.funcParametros.textos.textoErroBuscaRede}</li>`
          }
          if (this.funcParametros.especialidadeObrigatorio && (!this.params.id_especialidade || this.params.id_especialidade === '')) {
            erros += `<li>${this.funcParametros.textos.textoErroBuscaRede}</li>`
          }
        }
      } else {
        if (!this.params.nome || this.params.nome === '') {
          erros += `<li><b>Nome</b></li>`
        }
      }

      if (erros !== '') {
        this.dialogError.descricao = `<ul class="func-listagens">${erros}</ul>`
        return false
      } else {
        return true
      }
    },
    async listaAcreditacoes () {
      const result = await this.apiFuncionalidade.listaAcreditacoes({
        payload: {},
        handlerErrorIgnore: [404]
      })
      return result.data
    },
    async listaSecoes () {
      const result = await this.apiFuncionalidade.listaSecoes({
        payload: {
          idOperadora: this.aplicacao.idOperadora
        },
        handlerErrorIgnore: [404]
      })
      return result.data
    },
    formatTextosPrestador (prestador, formatType) {
      try {
        if (formatType) {
          prestador.nome = applyTextFormat(prestador.nome, formatType)
          prestador.esp = applyTextFormat(prestador.esp, formatType)
          prestador.bairro = applyTextFormat(prestador.bairro, formatType)
        }
      } catch (e) {
      }
      return prestador
    },
    openGuiaImpresso () {
      this.setViewGuiaImpresso(true)
    },
    async search (filtros = {}) {
      if (!this.validateForm()) {
        this.dialogError.show = true
        return
      }

      if (this.geolocalizacao.lat && this.geolocalizacao.lng) {
        this.params.lat = this.geolocalizacao.lat
        this.params.lon = this.geolocalizacao.lng
      } else {
        this.setGeolocalizacao({ lat: this.params.lat, lng: this.params.lon })
      }

      let params = { ...this.params }

      if (this.abaAtiva === 'esp') {
        params.nome = null
      } else if (this.abaAtiva === 'nome') {
        params.id_estado = null
        params.id_cidade = null
        params.id_bairro = null
        params.id_tipo_prestador = null
        params.id_especialidade = null
      }

      if (this.densidade > 0) return this.goToCompleteVersion()

      this.setServerError(false)

      this.setLoading(true)

      if (this.$route.query.detalhe) {
        this.$router.push({ path: `/4` })
        this.setViewDetalhe(false)
      }

      this.setRedeCredenciada({
        redeCredenciada: null,
        totalRegistros: 0,
        locations: [],
        acreditacoesLegenda: [],
        activeNames: []
      })
      this.locations = []

      let orderDist = false
      let orderAlfa = false

      if (filtros.order) {
        if (filtros.order === EnumFiltros.ORDER_DIST) {
          orderDist = true
        }
        if (filtros.order === EnumFiltros.ORDER_ALFA) {
          orderAlfa = true
        }
      } else {
        if (this.tipoLocalizacao === EnumTipoLocalizacao.GEOLOCATION && this.abaAtiva === 'esp') {
          orderDist = true
        } else if (this.tipoLocalizacao === EnumTipoLocalizacao.ADDRESS || this.abaAtiva === 'nome') {
          orderAlfa = true
        }
      }
      const result = await this.apiFuncionalidade.buscaRede({
        payload: {
          idOperadora: this.aplicacao.idOperadora,
          idPlano: params.id_plano,
          idEstado: params.id_estado,
          idCidade: params.id_cidade === 'TODOS' ? '' : params.id_cidade,
          bairro: params.id_bairro === 'TODOS' ? '' : params.id_bairro,
          tip: params.id_tipo_prestador,
          espec: params.id_especialidade,
          subespec: params.id_subespecialidade,
          nome: params.nome,
          espagr: this.funcParametros.agrupaEspecialidades ? 'S' : 'N',
          secoes: this.funcParametros.utilizaSecoes ? 'S' : 'N',
          dist: this.funcParametros.raioBuscaKm,
          lat: params.lat,
          lon: params.lon,
          orderDist: orderDist,
          orderAlfa: orderAlfa
        },
        handlerErrorIgnore: [404],
        loading: true
      })

      this.setFiltros({
        order: orderAlfa ? EnumFiltros.ORDER_ALFA : EnumFiltros.ORDER_DIST
      })

      if (result.data.data && result.data.data.length === 0) {
        this.setRedeCredenciada({
          redeCredenciada: [],
          totalRegistros: 0,
          locations: [],
          acreditacoesLegenda: [],
          activeNames: []
        })
        return
      }

      if (result.data && result.data.rede) {
        this.totalRegistros = 0
        let secoes = ''
        if (this.funcParametros.utilizaSecoes) {
          secoes = await this.listaSecoes()
        }

        this.acreditacoesLegenda = await this.listaAcreditacoes()

        if (this.funcParametros.utilizaSecoes && secoes.length) {
          const redePorSecoes = [...secoes]

          redePorSecoes.map((item) => {
            item.credenciados = result.data.rede.filter((value) => {
              if (value.sec_res === item.codigo_secao) {
                return value
              }
            })

            item.credenciados.map((credenciado) => {
              let acreditacoes = []
              if (credenciado.acreditacoes) {
                let acred = {}
                const arrAcreditacoes = credenciado.acreditacoes.split(',')
                if (Array.isArray(arrAcreditacoes)) {
                  arrAcreditacoes.map((item) => {
                    acred = this.acreditacoesLegenda.filter((value) => value.codigo === item.split(';')[1])
                    acreditacoes.push(acred[0])
                  })
                } else {
                  acred = credenciado.acreditacoes.filter((value) => value.codigo === item.split(';')[1])
                  acreditacoes.push(acred[0])
                }
              }
              credenciado.acreditacoes = acreditacoes
              credenciado = this.formatTextosPrestador(credenciado, this.funcParametros.formatacaoTexto)

              if (credenciado.lat && credenciado.lon) {
                let latitude = parseFloat(credenciado.lat.replace(',', '.'))
                let longitude = parseFloat(credenciado.lon.replace(',', '.'))
                this.locations.push({
                  refObject: credenciado,
                  coordenadas: [{ lat: latitude, long: longitude }]
                })
              }
            })

            item.totalRegistrosSecao = item.credenciados.length
            this.totalRegistros += item.totalRegistrosSecao
            this.activeNames.push(item.codigo_secao)
          })
          this.redeCredenciada = redePorSecoes
        } else {
          this.totalRegistros = result.data.rede.length

          result.data.rede.map((credenciado) => {
            let acreditacoes = []
            if (credenciado.acreditacoes) {
              let acred = {}
              const arrAcreditacoes = credenciado.acreditacoes.split(',')
              if (Array.isArray(arrAcreditacoes)) {
                arrAcreditacoes.map((item) => {
                  acred = this.acreditacoesLegenda.filter((value) => value.codigo === item.split(';')[1])
                  acreditacoes.push(acred[0])
                })
              } else {
                acred = this.acreditacoesLegenda.filter((value) => value.codigo === credenciado.acreditacoes.split(';')[1])
                acreditacoes.push(acred[0])
              }
            }
            credenciado.acreditacoes = acreditacoes
            credenciado = this.formatTextosPrestador(credenciado, this.funcParametros.formatacaoTexto)

            if (credenciado.lat && credenciado.lon) {
              let latitude = parseFloat(credenciado.lat.replace(',', '.'))
              let longitude = parseFloat(credenciado.lon.replace(',', '.'))
              this.locations.push({
                refObject: credenciado,
                coordenadas: [{ lat: latitude, long: longitude }]
              })
            }
          })

          this.redeCredenciada = result.data.rede
        }

        this.setRedeCredenciada({
          idPlano: params.id_plano,
          redeCredenciada: this.redeCredenciada,
          totalRegistros: this.totalRegistros,
          locations: this.locations,
          acreditacoesLegenda: this.acreditacoesLegenda,
          activeNames: this.activeNames
        })
      } else {
        this.setServerError(true)
        this.setRedeCredenciada({
          redeCredenciada: null,
          locations: [],
          totalRegistros: 0,
          acreditacoesLegenda: [],
          activeNames: []
        })
      }

      this.setLoading(false)
    },
    showEmpty () {
      this.setShowRedeVazia(true)
    },
    onChangeTipoLocalizacao (event) {
      switch (event) {
        case EnumTipoLocalizacao.ADDRESS:
          this.columnsConfig.localizacao = 12
          this.columnsConfig.estados = 12
          this.columnsConfig.cidades = 12
          this.columnsConfig.bairros = 12
          this.params.orderDist = false
          this.params.orderAlfa = true
          break
        case EnumTipoLocalizacao.GEOLOCATION:
          this.columnsConfig.localizacao = 24
          this.columnsConfig.estados = 8
          this.columnsConfig.cidades = 16
          this.columnsConfig.bairros = 24
          this.params.orderDist = true
          this.params.orderAlfa = false
          break
        default:
          this.columnsConfig.localizacao = 24
          this.columnsConfig.estados = 8
          this.columnsConfig.cidades = 16
          this.columnsConfig.bairros = 24
          this.params.orderDist = false
          this.params.orderAlfa = false
          break
      }
      this.params.id_estado = null
      this.params.id_cidade = null
      this.params.id_bairro = null
      this.params.id_tipo_prestador = null
      this.params.id_especialidade = null
      this.params.id_subespecialidade = null
    },
    useGeolocation () {
      if ((!this.geolocalizacao.lat && !this.geolocalizacao.lng) && (!this.params.lat && !this.params.lon)) {
        this.waitingPermissionGeolocation = true
      }
      this.getGeolocation()
    },
    abrirDescredenciados () {
      this.$router.push({ path: '/62' })
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.disableAutocomplete()
    setTimeout(() => this.initFilters(), 250)
  },
  watch: {
    changeFilters (newValue) {
      this.search(newValue)
    },
    'geolocalizacao.permissionState' (newValue) {
      if (newValue !== EnumGeolocationPermissionState.PROMPT) {
        this.waitingPermissionGeolocation = false
      }
    }
  }
}

</script>

<style lang="less">

#busca {
  padding-left: 10px;

  .el-select .el-input .el-select__caret {
    line-height: 0 !important;
  }

  .el-tabs--card > .el-tabs__header {
    border-bottom: 1px solid var(--cor-primaria-aplicacao);
  }

  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
    margin-left: 5px;
    margin-right: 10px;
  }

  .el-tabs__item {
    width: 47%;
    text-align: center;
    background-color: var(--cor-primaria-aplicacao-transparent);
    color: var(--cor-primaria-aplicacao);
    border-left: none !important;
    border-radius: 8px 8px 0 0;
    padding: 0 !important;
    //line-height: 40px;
    //height: 40px;
    //padding: 0 20px;
  }

  .el-tabs__item:hover {
    color: var(--cor-primaria-aplicacao);
  }

  .el-tabs__item.is-active {
    color: var(--cor-primaria-aplicacao);
    background-color: white;
    position: relative;
    top: 1px;
    border-bottom: none;
    border-left: 1px solid var(--cor-primaria-aplicacao) !important;
    border-top: 1px solid var(--cor-primaria-aplicacao);
    border-right: 1px solid var(--cor-primaria-aplicacao);
  }

  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    width: 100%;
  }

  div.el-tabs__nav.is-top {
    bottom: 0px !important;
  }

  .el-icon-circle-close {
    display: block;
    margin-top: -1px;
  }

  .divider {
    display: none;
  }

  .select-estado {
    padding-left: 10px;
  }

  .select-city {
    padding-left: 10px;
  }

  .select-bairro {
    padding-left: 10px;
  }

  &.densidade-0 {
    min-width: 375px;
    max-width: 375px;
    height: 100%;
    overflow-x: hidden;
    padding-right: 10px;
  }

  &.densidade-1 {
    min-width: 300px;

    .el-input .el-input__inner {
      padding-left: 10px !important;
    }
  }

  &.densidade-2 {
    min-width: 280px;

    label {
      position: absolute;
      z-index: 1;
      margin-left: 11px;
      margin-top: -6px;
      padding: 0 !important;
      color: dimgrey;
      font-weight: 100;
      font-size: 10px;
      text-transform: uppercase;
    }

    .el-input .el-input__inner {
      height: 40px !important;
      padding-top: 12px;
      font-size: 12px;
      padding-left: 10px !important;
    }
  }

  &.densidade-3 {
    min-width: 250px;

    label {
      position: absolute;
      z-index: 1;
      margin-top: -16px;
      margin-left: 10px;
      padding: 0 !important;
      color: dimgrey;
      font-weight: 100;
      font-size: 10px;
      text-transform: uppercase;
    }

    .el-input .el-input__inner {
      font-size: 12px;
      border: none;
      border-bottom: 1px solid lightgray;
      border-radius: 0;
    }

    .el-input.is-disabled .el-input__inner {
      background-color: transparent;
    }

    .divider {
      width: 1px;
      height: 47px;
      display: inline-block;
      background: lightgrey;
      position: absolute;
      margin-top: -12px;
    }

    .select-city {
      padding-left: 1px;
    }
  }
}

.el-form-item__label {
  padding: 0 0 5px 0 !important;
}

.densidade-1,
.densidade-2,
.densidade-3 {
  padding-right: 5px;

  .func-listagens {
    display: none;
    border-bottom: 1px solid #f3f3f3;
  }

  .func-4-title-header {
    display: none;
  }

  .el-dialog {
    margin: 10px;
    width: calc(100% - 20px);
    margin-top: calc(35%);
    border-radius: 8px;
  }
}

.densidade-1 {
  .el-select-dropdown {
    width: 300px;
    min-width: 300px !important;
  }

  .el-tabs__item {
    height: 36px;
    line-height: 35px;
  }

  .el-form-item__label {
    padding: 0 0 4px 0 !important;
  }

  .func-4-btn-pesquisar {
    height: 44px !important;
  }
}

.densidade-2 {
  .el-select-dropdown {
    width: 280px;
    min-width: 280px !important;
  }

  .el-tabs__item {
    height: 36px;
    line-height: 35px;
  }

  .func-4-btn-pesquisar {
    height: 44px !important;
  }

  .el-form-item {
    margin-bottom: 5px !important;
  }
}

.densidade-3 {
  .el-tabs__item {
    height: 31px;
    line-height: 30px;
  }

  .el-select-dropdown {
    width: 250px;
    min-width: 250px !important;
  }

  .el-form-item__content {
    line-height: 30px;
  }

  .func-4-btn-pesquisar {
    margin-top: initial !important;
  }

  .el-input__inner {
    padding-left: 10px;
  }

  .option-geolocation-title {
    font-size: 12px;
  }
}

.extended-option {
  height: initial;
  line-height: initial;
  padding: 8px 16px;

  .bold {
    font-weight: bold;
  }
}

.text-ellipses {
  text-overflow: ellipsis;
  overflow: hidden;
}

.option-geolocation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
  height: 47px;

  .el-button {
    padding: 10px 6px;
    pointer-events: auto;
    background-color: var(--cor-primaria-aplicacao);
  }

  .option-geolocation-title {
    font-weight: 600;
    color: var(--cor-primaria-aplicacao);
  }
}

.option-address {
  height: 47px;
  display: flex;
  align-items: center;
  span {
    font-weight: 600;
  }
}

</style>
